export const Logo = ({ dark = false }) => (
    <span className="flex items-center gap-3">
        <span className="block h-2.5 w-2.5 bg-[#C5A059] transition-transform duration-500 group-hover:rotate-45" />
        <span
            className={`font-serif-accent text-xl font-semibold tracking-tight ${
                dark ? "text-white" : "text-[#0D131F]"
            }`}
        >
            ALBL{" "}
            <span
                className={`italic font-normal ${
                    dark ? "text-slate-400" : "text-[#5B5B57]"
                }`}
            >
                Communications
            </span>
        </span>
    </span>
);
